import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const UpgradeQuotaModal = ({ show, onHide, message, onViewPlans }) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const isOrgAdmin = Boolean(
    user?.is_organization_admin ?? user?.is_organization_owner
  );

  const handleUpgrade = () => {
    onHide();
    if (typeof onViewPlans === 'function') {
      onViewPlans();
      return;
    }
    navigate('/plans');
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Plan limit reached</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          {message ||
            (isOrgAdmin
              ? 'You have reached your plan limit for this billing period. Upgrade your plan to send more envelopes.'
              : 'Your organization has reached its plan limit for this billing period. Ask an organization admin to upgrade the plan.')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          {isOrgAdmin ? 'Cancel' : 'Close'}
        </Button>
        {isOrgAdmin && (
          <Button variant="primary" onClick={handleUpgrade}>
            View plans
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UpgradeQuotaModal;
